import React, { useEffect } from "react";
import cl from "./Terms.module.css";
import { animateScroll as scroll } from "react-scroll";

const Terms = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <section className={cl.app_policy}>
      <h1>Términos y Condiciones</h1>
      <p>Última actualización: 07 de febrero de 2024</p>

      <p>
        Por favor, lee atentamente estos términos y condiciones antes de
        utilizar Nuestro Servicio.
      </p>
      <h2>Interpretación y Definiciones</h2>
      <h3>Interpretación</h3>
      <p>
        Las palabras con mayúscula inicial tienen significados definidos en las
        siguientes condiciones. Las siguientes definiciones tendrán el mismo
        significado independientemente de si aparecen en singular o en plural.
      </p>
      <h3>Definiciones</h3>
      <p>Para los propósitos de estos Términos y Condiciones:</p>
      <ul style={{ marginLeft: "30px" }}>
        <li>
          <p>
            <strong>Afiliado</strong> significa una entidad que controla, es
            controlada o está bajo control común con otra entidad, donde el
            "control" significa la propiedad del 50% o más de las acciones,
            intereses patrimoniales u otros títulos con derecho a voto para la
            elección de directores u otras autoridades de gestión.
          </p>
        </li>
        <li>
          <p>
            <strong>País</strong> se refiere a: Arkansas, Estados Unidos
          </p>
        </li>
        <li>
          <p>
            <strong>Compañía</strong> (también referida como "la Compañía",
            "Nosotros", "Nuestro" o "Nuestra" en este Acuerdo) se refiere a{" "}
            {props.shopName}.
          </p>
        </li>
        <li>
          <p>
            <strong>Dispositivo</strong> significa cualquier dispositivo que
            pueda acceder al Servicio, como una computadora, un teléfono móvil o
            una tableta digital.
          </p>
        </li>
        <li>
          <p>
            <strong>Servicio</strong> se refiere al Sitio Web.
          </p>
        </li>
        <li>
          <p>
            <strong>Términos y Condiciones</strong> (también referidos como
            "Términos") significan estos Términos y Condiciones que constituyen
            el acuerdo completo entre Tú y la Compañía con respecto al uso del
            Servicio. Estos Términos y Condiciones fueron creados con la ayuda
            del
            <a
              href="https://www.termsfeed.com/terms-conditions-generator/"
              target="_blank"
              rel="noreferrer"
            >
              Generador de Términos y Condiciones
            </a>
            .
          </p>
        </li>
        <li>
          <p>
            <strong>Servicio de Redes Sociales de Terceros</strong> significa
            cualquier servicio o contenido (incluidos datos, información,
            productos o servicios) proporcionado por un tercero que pueda ser
            visualizado, incluido o puesto a disposición a través del Servicio.
          </p>
        </li>
        <li>
          <p>
            <strong>Sitio Web</strong> se refiere a {props.shopName}, accesible
            desde {props.domain}
          </p>
        </li>
        <li>
          <p>
            <strong>Tú</strong> significa el individuo que accede o utiliza el
            Servicio, o la empresa u otra entidad legal en nombre de la cual
            dicho individuo accede o utiliza el Servicio, según corresponda.
          </p>
        </li>
      </ul>
      <h2>Reconocimiento</h2>
      <p>
        Estos son los Términos y Condiciones que rigen el uso de este Servicio y
        el acuerdo entre Tú y la Compañía. Estos Términos y Condiciones
        establecen los derechos y obligaciones de todos los usuarios con
        respecto al uso del Servicio.
      </p>
      <p>
        Tu acceso y uso del Servicio están condicionados a la aceptación y el
        cumplimiento de estos Términos y Condiciones. Estos Términos y
        Condiciones se aplican a todos los visitantes, usuarios y otras personas
        que accedan o utilicen el Servicio.
      </p>
      <p>
        Al acceder o utilizar el Servicio, aceptas quedar vinculado por estos
        Términos y Condiciones. Si no estás de acuerdo con alguna parte de estos
        Términos y Condiciones, no podrás acceder al Servicio.
      </p>
      <p>
        Declaras tener más de 18 años. La Compañía no permite que menores de 18
        años utilicen el Servicio.
      </p>
      <p>
        Tu acceso y uso del Servicio también están sujetos a la aceptación y el
        cumplimiento de la Política de Privacidad de la Compañía. Nuestra
        Política de Privacidad describe nuestras políticas y procedimientos
        sobre la recopilación, el uso y la divulgación de tu información
        personal cuando utilizas la Aplicación o el Sitio Web y te informa sobre
        tus derechos de privacidad y cómo la ley te protege. Lee atentamente
        nuestra Política de Privacidad antes de utilizar nuestro Servicio.
      </p>
      <h2>Enlaces a Otros Sitios Web</h2>
      <p>
        Nuestro Servicio puede contener enlaces a sitios web o servicios de
        terceros que no son propiedad ni están controlados por la Compañía.
      </p>
      <p>
        La Compañía no tiene control sobre, y no asume responsabilidad por, el
        contenido, las políticas de privacidad o las prácticas de ningún sitio
        web o servicio de terceros. Reconoces y aceptas además que la Compañía
        no será responsable ni tendrá responsabilidad, directa o indirectamente,
        por cualquier daño o pérdida causada o supuestamente causada por el uso
        o la confianza en dicho contenido, bienes o servicios disponibles en o a
        través de tales sitios web o servicios.
      </p>
      <p>
        Te recomendamos encarecidamente que leas los términos y condiciones y la
        política de privacidad de cualquier sitio web o servicio de terceros que
        visites.
      </p>
      <h2>Terminazione</h2>
      <p>
        Possiamo terminare o sospendere immediatamente il tuo accesso, senza
        preavviso o responsabilità, per qualsiasi motivo, incluso senza
        limitazioni se violi questi Termini e Condizioni.
      </p>
      <p>
        Alla terminazione, il tuo diritto di utilizzare il Servizio cesserà
        immediatamente.
      </p>
      <h2>Limitazione di Responsabilità</h2>
      <p>
        Senza considerare eventuali danni che Tu potresti subire, l'intera
        responsabilità della Compagnia e di qualunque suo fornitore ai sensi di
        qualsiasi disposizione di questi Termini e la tua esclusiva soluzione
        per tutto quanto precede sarà limitata all'importo effettivamente pagato
        da Te tramite il Servizio o a 100 USD se non hai acquistato nulla
        tramite il Servizio.
      </p>
      <p>
        Nella massima misura consentita dalla legge applicabile, in nessun caso
        la Compagnia o i suoi fornitori saranno responsabili per eventuali danni
        speciali, incidentali, indiretti o consequenziali (inclusi, ma non
        limitati a, danni per perdita di profitti, perdita di dati o di altre
        informazioni, per interruzione dell'attività, per lesioni personali,
        perdita di privacy derivante dall'uso o dall'impossibilità di utilizzare
        il Servizio, software o hardware di terze parti utilizzati con il
        Servizio, o in altro modo in relazione a qualsiasi disposizione di
        questi Termini), anche se la Compagnia o un qualsiasi fornitore fosse
        stato avvisato della possibilità di tali danni e anche se il rimedio
        fallisce nel suo scopo essenziale.
      </p>
      <p>
        Alcuni stati non consentono l'esclusione di garanzie implicite o la
        limitazione di responsabilità per danni incidentali o consequenziali, il
        che significa che alcune delle limitazioni di cui sopra potrebbero non
        essere applicabili. In questi stati, la responsabilità di ciascuna parte
        sarà limitata nella massima misura consentita dalla legge.
      </p>
      <h2>Disclaimer "COME È" e "COME DISPONIBILE"</h2>
      <p>
        Il Servizio ti viene fornito "COME È" e "COME DISPONIBILE" e con tutti i
        difetti e i difetti senza garanzia di alcun tipo. Nella misura massima
        consentita dalla legge applicabile, la Compagnia, per suo conto e per
        conto delle sue Affiliati e dei loro rispettivi licenzianti e fornitori
        di servizi, esclude espressamente tutte le garanzie, siano esse
        esplicite, implicite, legali o di altro tipo, relative al Servizio,
        comprese tutte le garanzie implicite di commerciabilità, idoneità per
        uno scopo particolare, titolo e non violazione, e le garanzie che
        possono derivare dal corso del negozio, dal corso dell'esecuzione,
        dall'uso o dalla pratica commerciale. Senza limitazioni a quanto
        precede, la Compagnia non fornisce alcuna garanzia o impegno, e non fa
        alcuna rappresentazione di alcun tipo che il Servizio soddisferà i tuoi
        requisiti, raggiungerà risultati desiderati, sarà compatibile o
        funzionerà con qualsiasi altro software, applicazioni, sistemi o
        servizi, funzionerà senza interruzioni, soddisferà eventuali standard di
        prestazioni o affidabilità o sarà privo di errori o che eventuali errori
        o difetti potranno o saranno corretti.
      </p>
      <p>
        Senza limitare quanto precede, né la Compagnia né alcun fornitore della
        Compagnia rilascia alcuna rappresentazione o garanzia di alcun tipo,
        esplicita o implicita: (i) riguardo al funzionamento o alla
        disponibilità del Servizio, o delle informazioni, contenuti e materiali
        o prodotti inclusi in esso; (ii) che il Servizio sarà privo di
        interruzioni o errori; (iii) riguardo all'accuratezza, affidabilità o
        attualità di qualsiasi informazione o contenuto fornito tramite il
        Servizio; o (iv) che il Servizio, i suoi server, i contenuti o le e-mail
        inviate da o per conto della Compagnia siano privi di virus, script,
        cavalli di Troia, worm, malware, bombe a orologeria o altri componenti
        dannosi.
      </p>
      <p>
        Alcune giurisdizioni non consentono l'esclusione di determinati tipi di
        garanzie o limitazioni sui diritti statutari applicabili di un
        consumatore, quindi alcune o tutte le esclusioni e limitazioni di cui
        sopra potrebbero non essere applicabili a Te. Ma in tal caso le
        esclusioni e limitazioni stabilite in questa sezione saranno applicate
        nella massima misura consentita dalla legge applicabile.
      </p>
      <h2>Legge Applicabile</h2>
      <p>
        Le leggi del Paese, escludendo le sue norme sulla conflittualità delle
        leggi, regoleranno questi Termini e il tuo utilizzo del Servizio. Il tuo
        utilizzo dell'Applicazione potrebbe anche essere soggetto ad altre leggi
        locali, statali, nazionali o internazionali.
      </p>
      <h2>Risoluzione delle Controversie</h2>
      <p>
        Se hai qualche preoccupazione o controversia riguardo al Servizio,
        accetti di cercare prima di risolvere la controversia informalmente
        contattando la Compagnia.
      </p>
      <h2>Per gli Utenti dell'Unione Europea (UE)</h2>
      <p>
        Se sei un consumatore dell'Unione Europea, beneficerai di qualsiasi
        disposizione obbligatoria della legge del Paese in cui risiedi.
      </p>
      <h2>Conformità Legale degli Stati Uniti</h2>
      <p>
        Dichiari e garantisci che (i) non ti trovi in un Paese soggetto al
        divieto del governo degli Stati Uniti, o che è stato designato dal
        governo degli Stati Uniti come un Paese "sostenitore del terrorismo", e
        (ii) non sei incluso in alcun elenco del governo degli Stati Uniti di
        parti proibite o soggette a restrizioni.
      </p>
      <h2>Divisibilità e Rinuncia</h2>
      <h3>Divisibilità</h3>
      <p>
        Se una disposizione di questi Termini viene ritenuta inapplicabile o
        invalida, tale disposizione verrà modificata e interpretata per
        conseguire gli obiettivi di tale disposizione nella massima misura
        possibile ai sensi della legge applicabile e le disposizioni restanti
        continueranno ad essere in pieno vigore ed effetto.
      </p>
      <h3>Rinuncia</h3>
      <p>
        Salvo diversamente previsto nel presente documento, la mancata
        esercitazione di un diritto o la mancanza di richiesta di adempiere a un
        obbligo ai sensi di questi Termini non pregiudicherà la capacità di una
        parte di esercitare tale diritto o richiedere tale adempimento in
        qualsiasi momento successivo, né la rinuncia a una violazione costituirà
        rinuncia a qualsiasi violazione successiva.
      </p>
      <h2>Interpretazione della Traduzione</h2>
      <p>
        Questi Termini e Condizioni potrebbero essere stati tradotti se li
        abbiamo resi disponibili sul nostro Servizio. Accetti che il testo
        originale in lingua inglese prevarrà in caso di controversia.
      </p>
      <h2>Modifiche a Questi Termini e Condizioni</h2>
      <p>
        Ci riserviamo il diritto, a nostra esclusiva discrezione, di modificare
        o sostituire questi Termini in qualsiasi momento. Se una revisione è
        sostanziale, faremo ragionevoli sforzi per fornire almeno 30 giorni di
        preavviso prima dell'entrata in vigore di eventuali nuovi termini. Cosa
        costituisca una modifica sostanziale sarà determinato a nostra esclusiva
        discrezione.
      </p>
      <p>
        Continuando ad accedere o utilizzare il nostro Servizio dopo che tali
        revisioni sono entrate in vigore, accetti di essere vincolato ai termini
        riveduti. Se non accetti i nuovi termini, in tutto o in parte, ti
        preghiamo di smettere di utilizzare il sito web e il Servizio.
      </p>
      <h2>Contattaci</h2>
      <p>Se hai domande su questi Termini e Condizioni, puoi contattarci:</p>
      <ul style={{ marginLeft: "30px" }}>
        <li>Per email: supporto@{props.domain}</li>
      </ul>
    </section>
  );
};

export default Terms;
